// frontend/src/App.js
import React, { useState, useEffect } from 'react';
import contentService from './services/contentService';
import { tienePantalla } from './utils/pantallas';
import { BrowserRouter as Router, Routes, Route, Navigate, Link, useLocation, useNavigate } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';
import CalendarView from './components/CalendarView';
import CalendarViewEventos from './components/CalendarViewEventos';
import CompetenciaList from './components/CompetenciaList';
import DesarrollaPage from './pages/DesarrollaPage';
import Login from './components/Login';
import InvitacionesPage from './pages/InvitacionesPage';
import Onboarding from './components/Onboarding';
import ProtectedRoute from './components/ProtectedRoute';
import ResetPassword from './components/ResetPassword';
import AdministracionCuentas from './pages/AdministracionCuentas';
import ProgramacionPost from './pages/ProgramacionPost';
import PostsPublicados from './pages/PostsPublicados';
import TermsInstagram from './pages/TermsInstagram';
import PrivacyInstagram from './pages/PrivacyInstagram';
import MaestroCategoriaPresupuesto from './pages/MaestroCategoriaPresupuesto';
import ViewPostPage from './pages/ViewPostPage';
import PerfilPage from './pages/PerfilPage';
import InstagramConexionPage from './pages/InstagramConexionPage';
import CuentasConectadasPage from './pages/CuentasConectadasPage';
import CuentasConectadasTikTokPage from './pages/CuentasConectadasTikTokPage';
import PlantillasPPTPage from './pages/PlantillasPPTPage';
import MetaAnalyticsPage from './pages/MetaAnalyticsPage';
import TikTokAnalyticsPage from './pages/TikTokAnalyticsPage';
import SocialinsiderPage from './pages/SocialinsiderPage';
import ReporteGeves from './pages/ReporteGeves';
import ReporteGevesVista from './pages/ReporteGevesVista';
import RankingPage from './pages/RankingPage';
import DiscoveryPage from './pages/DiscoveryPage';
import TrackedPage from './pages/TrackedPage';
import MercadoPage from './pages/MercadoPage';
import ReportePage from './pages/ReportePage';
import UsoPage from './pages/UsoPage';
import AprobacionesPage from './pages/AprobacionesPage';
import VencidosPage from './pages/VencidosPage';
import authService from './services/authService';
import './App.css';
import './styles/geves-design-system.css';
import './styles/modals.css';

// Importa las páginas públicas
import InstagramDiscoveryPage from './pages/InstagramDiscoveryPage';
import ConectarInstagramPublic from './pages/ConectarInstagramPublic';
import ConectarInstagramDirectPublic from './pages/ConectarInstagramDirectPublic';
import ConectarTikTokPublic from './pages/ConectarTikTokPublic';
import TikTokDemoScopes from './pages/TikTokDemoScopes';

// Comments pages
import InstagramCommentsPage from './pages/InstagramCommentsPage';
import TikTokCommentsPage from './pages/TikTokCommentsPage';
import InstagramStories from './pages/InstagramStories';

// Kanban components
import KanbanTableros from './pages/KanbanTableros';
import KanbanInvitaciones from './pages/KanbanInvitaciones';

// Presupuestos components
import PresupuestosPage from './pages/PresupuestosPage';

// OneBase components
import OneBaseRoutes from './routes/OneBaseRoutes';

// Global Footer
import GlobalFooter from './components/GlobalFooter';

// Contabilidad components
import PlanCuentas from './pages/PlanCuentas';
import BalanceGeneralPage from './pages/BalanceGeneralPage';
import EstadoResultadoPage from './pages/EstadoResultadoPage';
import AnalisisCuentasPage from './pages/AnalisisCuentasPage';
import FlujoCajaPage from './pages/FlujoCajaPage';

// Tesorería components
import CuentasBancariasPage from './pages/CuentasBancariasPage';
import PagosPage from './pages/PagosPage';
import CuentasPorCobrarPage from './pages/CuentasPorCobrarPage';
import CuentasPorPagarPage from './pages/CuentasPorPagarPage';
import ConciliacionBancariaPage from './pages/ConciliacionBancariaPage';

// Contabilidad avanzada components
import CentrosCostoPage from './pages/CentrosCostoPage';
import ActivosFijosPage from './pages/ActivosFijosPage';
import ViaticosPage from './pages/ViaticosPage';
import CierreContablePage from './pages/CierreContablePage';

// Tributario components
import LibroCompraVentaPage from './pages/LibroCompraVentaPage';
import RetencionesPage from './pages/RetencionesPage';
import ResumenIVAPage from './pages/ResumenIVAPage';

// Reportes avanzados components
import LibroMayorPage from './pages/LibroMayorPage';
import BalanceComprobacionPage from './pages/BalanceComprobacionPage';
import FlujoCajaRealPage from './pages/FlujoCajaRealPage';
import PresupuestoVsRealPage from './pages/PresupuestoVsRealPage';
import RentabilidadCentroPage from './pages/RentabilidadCentroPage';
import ReporteActivosPage from './pages/ReporteActivosPage';
import ReporteViaticosPage from './pages/ReporteViaticosPage';

// Proyectos Gantt
import ProyectosGanttPage from './pages/ProyectosGanttPage';

// Bodega components
import BodegasPage from './pages/BodegasPage';
import RecursosBodegaPage from './pages/RecursosBodegaPage';
import StocksBodegaPage from './pages/StocksBodegaPage';
import MovimientosBodegaPage from './pages/MovimientosBodegaPage';
import SolicitudesBodegaPage from './pages/SolicitudesBodegaPage';

// Soporte components
import SoporteBooking from './components/SoporteBooking';

// Trends Analytics components
import TrendsPage from './pages/TrendsPage';

// CamDoBrain components
import CamDoBrainSetup from './pages/CamDoBrainSetup';
import CamDoBrainRecommendation from './pages/CamDoBrainRecommendation';
import CamDoBrainWeeklyPlan from './pages/CamDoBrainWeeklyPlan';
import CamDoBrainDiagnostic from './pages/CamDoBrainDiagnostic';
import CamDoBrainObjectives from './pages/CamDoBrainObjectives';
import CamDoBrainNews from './pages/CamDoBrainNews';
import CamDoBrainCalendar from './pages/CamDoBrainCalendar';
import CamDoBrainCompetitors from './pages/CamDoBrainCompetitors';
import CamDoBrainTrends from './pages/CamDoBrainTrends';
import CompetenciaTrackerPage from './pages/CompetenciaTrackerPage';
import CamDoBrainPredictions from './pages/CamDoBrainPredictions';
import CamDoBrainQLearning from './pages/CamDoBrainQLearning';
import ConfiguracionInformeEmail from './pages/ConfiguracionInformeEmail';

// Cronómetro global
import { CronometroProvider } from './context/CronometroContext';
import GlobalCronometroToast from './components/GlobalCronometroToast';

// Centro de notificaciones
import { NotificationsProvider } from './context/NotificationsContext';
import NotificationsBell from './components/NotificationsBell';
import AccountSwitcher from './components/AccountSwitcher';

import Loading from './components/Loading';
// ⭐ Componente para scroll to top cuando cambia de ruta
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

// Registra la pantalla actual del usuario para /uso (Usuarios en plataforma)
function ActivityPing({ user }) {
  const location = useLocation();

  useEffect(() => {
    if (!user) return;
    const p = location.pathname;
    if (p === '/login' || p.startsWith('/conectar-')) return;
    contentService.pingActivity(p).catch(() => {});
  }, [user, location.pathname]);

  return null;
}

// 🆕 Componente wrapper para ViewPostPage que maneja autenticación
function ViewPostPageWrapper({ user }) {
  const location = useLocation();

  if (!user) {
    // Redirigir a login con la URL actual como parámetro 'next'
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return <ViewPostPage />;
}

// Componente sidebar lateral (reemplaza AppHeader)
// Roles con acceso a la seccion "Geves" del sidebar (Informes, Analytics, Reportes, Ranking, Match).
// Para dar acceso a un nuevo usuario: asignarle uno de estos roles desde Usuarios > Rol (no requiere deploy ni tocar este archivo).
const GEVES_ROLES = ['Administrador'];
const canAccessGeves = (u) => !!u && (u.is_superuser || GEVES_ROLES.includes(u.role));

function AppSidebar({ user, handleLogout, collapsed, onToggle }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [openSection, setOpenSection] = useState(null);
  const [openSubsection, setOpenSubsection] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Iniciales del usuario
  const getUserInitials = () => {
    const name = user.full_name || user.username || '';
    const parts = name.trim().split(' ').filter(p => p.length > 0);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return 'US';
  };

  // Cerrar al cambiar de ruta
  useEffect(() => {
    setMobileOpen(false);
    setOpenSection(null);
    setOpenSubsection(null);
  }, [location.pathname]);

  // No mostrar en rutas públicas
  const isPublicRoute = location.pathname.startsWith('/conectar-instagram/') ||
                        location.pathname.startsWith('/conectar-instagram-direct/') ||
                        location.pathname.startsWith('/conectar-tiktok/') ||
                        location.pathname === '/login' ||
                        location.pathname.startsWith('/reset-password/') ||
                        location.pathname === '/onboarding' ||
                        location.pathname.startsWith('/instagram/terms-of-service') ||
                        location.pathname.startsWith('/instagram/privacy-policy') ||
                        location.pathname === '/reporte-geves-vista';

  if (!user || isPublicRoute) return null;

  const isActive = (path) => path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
  const close = () => setMobileOpen(false);
  const toggleSection = (name) => setOpenSection(prev => prev === name ? null : name);
  const toggleSub = (name, e) => { e && e.stopPropagation(); setOpenSubsection(prev => prev === name ? null : name); };

  // Componentes internos auxiliares
  const SbLink = ({ to, children, sub, subsub, exact }) => {
    const active = exact ? location.pathname === to : isActive(to);
    return (
      <Link to={to} onClick={close}
        className={`sb-link${sub ? ' sb-sub' : ''}${subsub ? ' sb-subsub' : ''}${active ? ' sb-active' : ''}`}>
        {children}
      </Link>
    );
  };

  const SbBtn = ({ children, onClick, sub, active }) => (
    <button className={`sb-link${sub ? ' sb-sub' : ''}${active ? ' sb-active' : ''}`} onClick={onClick}>
      {children}
    </button>
  );

  return (
    <>
      {/* Overlay mobile */}
      {mobileOpen && <div className="sb-overlay" onClick={close} />}

      {/* Hamburger mobile */}
      <button className="sb-hamburger" onClick={() => setMobileOpen(true)} aria-label="Abrir menú">
        <FiMenu size={18} />
      </button>

      <aside className={`app-sidebar${collapsed ? ' sb-collapsed' : ''}${mobileOpen ? ' sb-mobile-open' : ''}`}>

        {/* ── Header: logo + botón colapsar ── */}
        <div className="sb-header">
          <img
            src="https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/logos/logo-geves-oscuro.png"
            alt="Geves"
            className="app-logo"
          />
          <button className="sb-toggle-btn" onClick={onToggle} title={collapsed ? 'Expandir' : 'Colapsar'}>
            {collapsed ? '›' : '‹'}
          </button>
        </div>

        {/* ── Nav ── */}
        <nav className="sb-nav">


          {/* === WORKFLOW === */}
          {(tienePantalla(user, 'calendario') || tienePantalla(user, 'aprobaciones') || tienePantalla(user, 'vencidos')) && (
            <p className="sb-section-label">Planificación</p>
          )}
          {tienePantalla(user, 'calendario') && (
            <SbLink to="/" exact>
              <i className="bi bi-calendar3"></i>
              <span className="sb-label">Calendario</span>
            </SbLink>
          )}
          {tienePantalla(user, 'aprobaciones') && (
            <SbLink to="/aprobaciones">
              <i className="bi bi-check2-circle"></i>
              <span className="sb-label">Aprobaciones</span>
            </SbLink>
          )}
          {tienePantalla(user, 'vencidos') && (
            <SbLink to="/vencidos">
              <i className="bi bi-exclamation-triangle"></i>
              <span className="sb-label">Vencidos</span>
            </SbLink>
          )}

          {/* === GEVES === */}
          {tienePantalla(user, 'informes') && (<>
            <hr className="sb-divider" />
            <p className="sb-section-label">Geves</p>
            <SbLink to="/informe-semanal">
              <i className="bi bi-bar-chart-line"></i>
              <span className="sb-label">Informes</span>
            </SbLink>
          </>)}
          {tienePantalla(user, 'reportes') && (<>
            {!tienePantalla(user, 'informes') && (<>
              <hr className="sb-divider" />
              <p className="sb-section-label">Geves</p>
            </>)}
            <SbLink to="/reporte-geves">
              <i className="bi bi-graph-up-arrow"></i>
              <span className="sb-label">Reportes</span>
            </SbLink>
          </>)}

          {/* === CONFIGURACIÓN === */}
          {(user.is_superuser || tienePantalla(user, 'uso') || tienePantalla(user, 'plantillas_ppt') || tienePantalla(user, 'configuracion')) && (<>
            <hr className="sb-divider" />
            <p className="sb-section-label">Configuración</p>
            <SbBtn onClick={() => toggleSection('config')}>
              <i className="bi bi-gear"></i>
              <span className="sb-label">Sistema</span>
              <span className={`sb-arrow${openSection === 'config' ? ' open' : ''}`}>›</span>
            </SbBtn>
            {openSection === 'config' && (
              <div className="sb-group-items">
                {user.is_superuser && <SbLink to="/admin-cuentas" sub><span className="sb-label">Admin. de cuentas</span></SbLink>}
                {tienePantalla(user, 'uso') && <SbLink to="/uso" sub><span className="sb-label">Uso</span></SbLink>}
                {tienePantalla(user, 'plantillas_ppt') && <SbLink to="/configuracion/plantillas-ppt" sub><span className="sb-label">Plantillas PPT</span></SbLink>}
                {tienePantalla(user, 'configuracion') && <SbLink to="/desarrolla" sub><span className="sb-label">Configuración</span></SbLink>}
              </div>
            )}
          </>)}

        </nav>

        {/* ── Footer: notificaciones + usuario ── */}
        <div className="sb-footer">
          <div className="sb-cuenta-row">
            <AccountSwitcher variant="sidebar" />
          </div>
          <div className="sb-user-row">
            <div className="sb-avatar" onClick={() => { navigate('/perfil'); close(); }} title="Ir a Perfil">
              {getUserInitials()}
            </div>
            <div className="sb-user-info">
              <span className="sb-username">{user.full_name || user.username}</span>
              <div className="sb-user-actions">
                <button className="sb-user-btn" onClick={() => { navigate('/perfil'); close(); }}>Perfil</button>
                <span className="sb-user-sep">·</span>
                <button className="sb-user-btn" onClick={handleLogout}>Salir</button>
              </div>
            </div>
            <NotificationsBell />
          </div>
        </div>

      </aside>
    </>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const isPublicRoute = window.location.pathname.startsWith('/conectar-instagram/') ||
                            window.location.pathname.startsWith('/conectar-instagram-direct/') ||
                            window.location.pathname.startsWith('/conectar-tiktok/') ||
                            window.location.pathname.startsWith('/instagram/terms-of-service') ||
                            window.location.pathname.startsWith('/instagram/privacy-policy');

      if (isPublicRoute) {
        setLoading(false);
        return;
      }

      await authService.getCSRFToken();
      const currentUser = await authService.getCurrentUser();
      setUser(currentUser);
    } catch (error) {
      console.error('Error al verificar autenticación:', error);
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        setUser(null);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLoginSuccess = async (userData) => {
    try {
      // Obtener datos completos del usuario (incluyendo groups)
      const currentUser = await authService.getCurrentUser();
      setUser(currentUser);
    } catch (error) {
      console.error('Error al obtener datos del usuario:', error);
      // Fallback: usar los datos del login
      setUser(userData);
    }
  };

  const handleLogout = async () => {
    try {
      await authService.logout();
      setUser(null);
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      setUser(null);
    }
  };

  if (loading) {
    return (
      <Loading />
    );
  }

  return (
    <Router>
      <ScrollToTop />
      <ActivityPing user={user} />
      <CronometroProvider>
        <NotificationsProvider user={user}>
          <div className={`App${user ? ' with-sidebar' : ''}${sidebarCollapsed ? ' sb-is-collapsed' : ''}`}>
            {user && <GlobalCronometroToast />}
            <AppSidebar
              user={user}
              handleLogout={handleLogout}
              collapsed={sidebarCollapsed}
              onToggle={() => setSidebarCollapsed(c => !c)}
            />
            <div className={user ? 'app-content' : ''}>
          <Routes>
            <Route path="/conectar-instagram/:token" element={<ConectarInstagramPublic />} />
            <Route path="/conectar-instagram-direct/:token" element={<ConectarInstagramDirectPublic />} />
            <Route path="/conectar-tiktok/:token" element={<ConectarTikTokPublic />} />
            <Route path="/instagram/terms-of-service" element={<TermsInstagram />} />
            <Route path="/instagram/privacy-policy" element={<PrivacyInstagram />} />
            <Route path="/view-post/:postId" element={<ViewPostPageWrapper user={user} />} />

            <Route
              path="/login"
              element={user ? <Navigate to="/" /> : <Login onLoginSuccess={handleLoginSuccess} />}
            />
            <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
            <Route path="/onboarding" element={<Onboarding />} />

            <Route path="/" element={user ? <CalendarView user={user} /> : <Navigate to="/login" />} />
            <Route path="/programacion" element={user ? <ProgramacionPost /> : <Navigate to="/login" />} />
            <Route path="/publicados" element={user ? <PostsPublicados user={user} /> : <Navigate to="/login" />} />
            <Route path="/eventos/calendario" element={user ? <CalendarViewEventos user={user} /> : <Navigate to="/login" />} />
            <Route path="/eventos/gantt" element={user ? <ProyectosGanttPage /> : <Navigate to="/login" />} />
            <Route path="/influencers" element={<Navigate to="/desarrolla?tab=cuentas" replace />} />
            <Route path="/competencia" element={user ? <CompetenciaList /> : <Navigate to="/login" />} />

            {/* Rutas Comments Analytics */}
            <Route path="/instagram/comments" element={user ? <InstagramCommentsPage /> : <Navigate to="/login" />} />
            <Route path="/tiktok/comments" element={user ? <TikTokCommentsPage /> : <Navigate to="/login" />} />

            {/* Rutas Instagram Stories */}
            <Route path="/instagram/stories" element={user ? <InstagramStories /> : <Navigate to="/login" />} />

            {/* Rutas Kanban */}
            <Route path="/kanban/invitaciones" element={user ? <KanbanInvitaciones /> : <Navigate to="/login" />} />
            <Route path="/kanban/invitations/:token/accept" element={user ? <KanbanInvitaciones /> : <Navigate to="/login" />} />
            <Route path="/kanban" element={user ? <KanbanTableros /> : <Navigate to="/login" />} />

            {/* Rutas Presupuestos */}
            <Route path="/presupuestos" element={user ? <PresupuestosPage /> : <Navigate to="/login" />} />

            {/* Rutas OneBase ERP */}
            <Route
              path="/onebase/*"
              element={
                <ProtectedRoute isAuthenticated={!!user} loading={false}>
                  <OneBaseRoutes isAuthenticated={!!user} loading={false} />
                </ProtectedRoute>
              }
            />

            {/* Rutas Contabilidad */}
            <Route path="/contabilidad/plan-cuentas" element={user ? <PlanCuentas user={user} /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/reportes/balance-general" element={user ? <BalanceGeneralPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/reportes/estado-resultado" element={user ? <EstadoResultadoPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/reportes/analisis-cuentas" element={user ? <AnalisisCuentasPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/reportes/flujo-caja" element={user ? <FlujoCajaPage /> : <Navigate to="/login" />} />

            {/* Rutas Tesorería */}
            <Route path="/contabilidad/cuentas-bancarias" element={user ? <CuentasBancariasPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/pagos" element={user ? <PagosPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/cuentas-por-cobrar" element={user ? <CuentasPorCobrarPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/cuentas-por-pagar" element={user ? <CuentasPorPagarPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/conciliacion-bancaria" element={user ? <ConciliacionBancariaPage /> : <Navigate to="/login" />} />

            {/* Rutas Contabilidad Avanzada */}
            <Route path="/contabilidad/centros-costo" element={user ? <CentrosCostoPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/activos-fijos" element={user ? <ActivosFijosPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/viaticos" element={user ? <ViaticosPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/cierre-contable" element={user ? <CierreContablePage /> : <Navigate to="/login" />} />

            {/* Rutas Tributario */}
            <Route path="/contabilidad/libro-compra-venta" element={user ? <LibroCompraVentaPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/retenciones" element={user ? <RetencionesPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/resumen-iva" element={user ? <ResumenIVAPage /> : <Navigate to="/login" />} />

            {/* Rutas Reportes Avanzados */}
            <Route path="/contabilidad/reportes/libro-mayor" element={user ? <LibroMayorPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/reportes/balance-comprobacion" element={user ? <BalanceComprobacionPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/reportes/flujo-caja-real" element={user ? <FlujoCajaRealPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/reportes/presupuesto-vs-real" element={user ? <PresupuestoVsRealPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/reportes/rentabilidad-centro" element={user ? <RentabilidadCentroPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/reportes/activos-fijos" element={user ? <ReporteActivosPage /> : <Navigate to="/login" />} />
            <Route path="/contabilidad/reportes/viaticos" element={user ? <ReporteViaticosPage /> : <Navigate to="/login" />} />

            {/* Rutas Bodega */}
            <Route path="/bodega/bodegas" element={user ? <BodegasPage /> : <Navigate to="/login" />} />
            <Route path="/bodega/recursos" element={user ? <RecursosBodegaPage /> : <Navigate to="/login" />} />
            <Route path="/bodega/stocks" element={user ? <StocksBodegaPage /> : <Navigate to="/login" />} />
            <Route path="/bodega/solicitudes" element={user ? <SolicitudesBodegaPage /> : <Navigate to="/login" />} />
            <Route path="/bodega/movimientos" element={user ? <MovimientosBodegaPage /> : <Navigate to="/login" />} />

            {/* Ruta Soporte */}
            <Route path="/soporte" element={user ? <SoporteBooking /> : <Navigate to="/login" />} />

            {/* Ruta Trends Analytics */}
            <Route path="/tendencias" element={user ? <TrendsPage /> : <Navigate to="/login" />} />

            {/* Rutas CamDoBrain */}
            <Route path="/camdobrain/setup" element={user ? <CamDoBrainSetup /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/brand/:brandId" element={user ? <CamDoBrainSetup /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/recommendation/:predictionId" element={user ? <CamDoBrainRecommendation /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/predictions" element={user ? <CamDoBrainPredictions /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/weekly-plan" element={user ? <CamDoBrainWeeklyPlan /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/diagnostic" element={user ? <CamDoBrainDiagnostic /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/objectives" element={user ? <CamDoBrainObjectives /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/news" element={user ? <CamDoBrainNews /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/trends" element={user ? <CamDoBrainTrends /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/suggestions" element={user ? <Navigate to="/fendobrain/qlearning" replace /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/calendar" element={user ? <CamDoBrainCalendar /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/competitors" element={user ? <CamDoBrainCompetitors /> : <Navigate to="/login" />} />
            <Route path="/workflow/competencia" element={user ? <CompetenciaTrackerPage /> : <Navigate to="/login" />} />
            <Route path="/camdobrain/qlearning" element={user ? <Navigate to="/fendobrain/qlearning" replace /> : <Navigate to="/login" />} />
            <Route path="/fendobrain/qlearning" element={user ? <CamDoBrainQLearning /> : <Navigate to="/login" />} />

            <Route path="/informe-semanal" element={tienePantalla(user, 'informes') ? <ConfiguracionInformeEmail /> : <Navigate to={user ? "/" : "/login"} replace />} />

            <Route path="/perfil" element={user ? <PerfilPage /> : <Navigate to="/login" />} />
            <Route path="/instagram/conexion" element={user ? <InstagramConexionPage /> : <Navigate to="/login" />} />
            <Route path="/configuracion/cuentas-conectadas" element={user ? <CuentasConectadasPage /> : <Navigate to="/login" />} />
            <Route path="/configuracion/cuentas-conectadas-tiktok" element={user ? <CuentasConectadasTikTokPage /> : <Navigate to="/login" />} />
            <Route path="/configuracion/plantillas-ppt" element={tienePantalla(user, 'plantillas_ppt') ? <PlantillasPPTPage /> : <Navigate to={user ? "/" : "/login"} replace />} />
            <Route path="/meta-analytics" element={canAccessGeves(user) ? <MetaAnalyticsPage /> : <Navigate to={user ? "/" : "/login"} replace />} />
            <Route path="/tiktok-analytics" element={canAccessGeves(user) ? <TikTokAnalyticsPage /> : <Navigate to={user ? "/" : "/login"} replace />} />
            <Route path="/socialinsider" element={user ? <SocialinsiderPage /> : <Navigate to="/login" />} />
            <Route path="/reporte-geves" element={tienePantalla(user, 'reportes') ? <ReporteGeves /> : <Navigate to={user ? "/" : "/login"} replace />} />
            <Route path="/reporte-geves-vista" element={<ReporteGevesVista />} />
            <Route path="/ranking" element={canAccessGeves(user) ? <RankingPage /> : <Navigate to={user ? "/" : "/login"} replace />} />
            <Route path="/mercado" element={user ? <MercadoPage /> : <Navigate to="/login" />} />
            <Route path="/discovery" element={user ? <DiscoveryPage /> : <Navigate to="/login" />} />
            <Route path="/tracked" element={user ? <TrackedPage /> : <Navigate to="/login" />} />
            <Route path="/reporte" element={<ReportePage user={user} />} />
            <Route path="/uso" element={tienePantalla(user, 'uso') ? <UsoPage /> : <Navigate to={user ? "/" : "/login"} replace />} />
            <Route path="/aprobaciones" element={tienePantalla(user, 'aprobaciones') ? <AprobacionesPage /> : <Navigate to={user ? "/" : "/login"} replace />} />
            <Route path="/vencidos" element={tienePantalla(user, 'vencidos') ? <VencidosPage /> : <Navigate to={user ? "/" : "/login"} replace />} />
            <Route path="/usuarios" element={<Navigate to="/desarrolla?tab=usuarios" replace />} />
            <Route path="/admin-cuentas" element={user?.is_superuser ? <AdministracionCuentas /> : <Navigate to={user ? "/" : "/login"} replace />} />
            <Route path="/maestro-grupos" element={<Navigate to="/desarrolla?tab=usuarios" replace />} />
            <Route path="/etiquetas" element={<Navigate to="/desarrolla?tab=etiquetas" replace />} />
            <Route path="/maestro-categorias-presupuesto" element={user ? <MaestroCategoriaPresupuesto /> : <Navigate to="/login" />} />
            <Route path="/desarrolla" element={tienePantalla(user, 'configuracion') ? <DesarrollaPage user={user} /> : <Navigate to={user ? "/" : "/login"} replace />} />
            <Route path="/instagram/discovery" element={user ? <InstagramDiscoveryPage /> : <Navigate to="/login" />} />

            <Route
              path="/invitaciones"
              element={
                <ProtectedRoute user={user} requiredRole="Administrador">
                  <InvitacionesPage />
                </ProtectedRoute>
              }
            />

            {/* Catch-all route - pero NO capturar rutas de Django backend */}
            <Route
              path="*"
              element={
                (() => {
                  const path = window.location.pathname;
                  // Excluir rutas de Django/API del catch-all
                  const isDjangoRoute =
                    path.startsWith('/tiktok/api/') ||
                    path.startsWith('/instagram/') ||
                    path.startsWith('/api/');

                  return isDjangoRoute ? null : <Navigate to="/" />;
                })()
              }
            />
          </Routes>
          <GlobalFooter />
            </div>{/* /app-content */}
        </div>
        </NotificationsProvider>
      </CronometroProvider>
    </Router>
  );
}

export default App;